import { render, staticRenderFns } from "./Zimmerreservationsliste.vue?vue&type=template&id=0161b91e"
import script from "./Zimmerreservationsliste.vue?vue&type=script&lang=js"
export * from "./Zimmerreservationsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports